import React, { useContext, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext'; // Assuming the context is in AuthContext.tsx
import { confirmResetPassword, fetchAuthSession, type ConfirmResetPasswordInput } from 'aws-amplify/auth';
import { updatePassword, type UpdatePasswordInput } from 'aws-amplify/auth';
import { authGetUser, handleResetPassword } from '../services/authService';
import { useToast } from '../context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { UserRoleContext } from '../context/UserRoleContext';
import loginBackground from '../assets/loginBackground.jpg';
import logo from '../assets/logo.png';
import { ROUTES } from '../constants/routes';

const WelcomePage: React.FC = () => {
  const { signIn, error, loading, isAuthenticated, gotToVerify } = useAuth();  // Get signIn function, loading, and error states from AuthContext
  const { setUserRole } = useContext(UserRoleContext);
  const { addToast } = useToast();
  const navigate = useNavigate();

  // Handle login form submission
  const toLogin = async () => {
    navigate(ROUTES.LOGIN);
  };

  const toCreateAccount = () => {
    navigate(ROUTES.CREATE_ACCOUNT);
  }

  const checkAuth = async () => {
    let user = await fetchAuthSession();
    if (user.userSub) {
      navigate(ROUTES.HOME);
    }
  }

  useEffect(() => {
    checkAuth();
  }, [])



  if (isAuthenticated) {
    // Redirect to dashboard or home if the user is already authenticated
    return <div>You're already logged in. Redirecting to the dashboard...</div>;
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 100px)',
      backgroundImage: `url(${loginBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      margin: '0px'
    }}>
      <div style={{ marginTop: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <img src={logo} alt="Cyne Up" style={{ maxWidth: '75vw', width: '400px', minWidth: '300px', justifyContent: 'center' }} />
        <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', gap: '30px', justifyContent: 'center', marginTop: '10px' }}>
          <div className='card' style={{ padding: '20px', backgroundColor: 'rgba(255, 255, 255, 1.0)', backdropFilter: 'blur(10px)', width: '300px', alignItems: 'center' }}>
            <h1 style={{ textAlign: 'center' }}>Welcome Back</h1>

            <button type='button' style={{ width: '100%', backgroundColor: '#51BCE4' }} onClick={() => toLogin()}>Login</button>

          </div>

          <div className='card' style={{ padding: '20px', backgroundColor: 'rgba(255, 255, 255, 1.0)', backdropFilter: 'blur(10px)', width: '300px', alignItems: 'center' }}>
            <h1 style={{ textAlign: 'center' }}>New Here?</h1>

            <button type='button' style={{ width: '100%', backgroundColor: '#51BCE4' }} onClick={() => toCreateAccount()}>Create An Account</button>

          </div>
        </div>
                <h2 style={{color: 'white'}}><i>The Fastest Cyber Sign Up</i></h2>

      </div>
    </div>
  );
};

export default WelcomePage;
